module.exports = __webpack_public_path__ + "static/en-au-2a48d853c12e5823eccc94fc172cbe1b.svg";